module.exports = __webpack_public_path__ + "img/xihuan.ae57ea06.png";